import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { ButtonDefinition, PickerValue } from '../generic-picker/generic-picker.component';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'lib-month-picker',
  templateUrl: './month-picker.component.html',
  styleUrls: ['./month-picker.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MonthPickerComponent),
      multi: true
    }
  ],
  standalone: false
})
export class MonthPickerComponent implements OnInit, ControlValueAccessor {
  @Input()
  public minimumValue: PickerValue | null;
  @Input()
  public maximumValue: PickerValue | null;

  public val: PickerValue;
  private onChange = (_: any) => {};
  public availableOptions: ButtonDefinition[];

  constructor() {
    const isDisabled = (val: any) => this._getDisabled(val);
    this.availableOptions = [
      ButtonDefinition.Build('January', 1, isDisabled),
      ButtonDefinition.Build('February', 2, isDisabled),
      ButtonDefinition.Build('March', 3, isDisabled),
      ButtonDefinition.Build('April', 4, isDisabled),
      ButtonDefinition.Build('May', 5, isDisabled),
      ButtonDefinition.Build('June', 6, isDisabled),
      ButtonDefinition.Build('July', 7, isDisabled),
      ButtonDefinition.Build('August', 8, isDisabled),
      ButtonDefinition.Build('September', 9, isDisabled),
      ButtonDefinition.Build('October', 10, isDisabled),
      ButtonDefinition.Build('November', 11, isDisabled),
      ButtonDefinition.Build('December', 12, isDisabled)
    ];
  }
  public get buttonText() {
    const selected = this.availableOptions?.find(x => x.value === this.val.value) ?? {
      text: 'wait'
    };
    return `${selected.text} ${this.val.year}`;
  }
  ngOnInit(): void {}
  public valueChanged(val: PickerValue) {
    this.val = val;
    this.onChange({ value: val.value, year: val.year });
  }

  public registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {}

  setDisabledState(isDisabled: boolean): void {}

  public writeValue(val: PickerValue): void {
    if (val != null) {
      this.val = { value: val.value, year: val.year };
    }
  }

  public disableDecrementYear() {
    return this.minimumValue != null && this.minimumValue.year === this.val.year;
  }
  public disableIncrementYear() {
    return this.maximumValue != null && this.maximumValue.year === this.val.year;
  }

  private _getDisabled(value: number) {
    let result = false;
    if (this.minimumValue != null) {
      const year = this.val.year;
      const dateToTest = new Date(year, value - 1);
      const minDate = new Date(this.minimumValue.year, this.minimumValue.value - 1);
      result = dateToTest < minDate;
    }
    if (result) return result;
    if (this.maximumValue != null) {
      const year = this.val.year;
      const dateToTest = new Date(year, value - 1);
      const maxDate = new Date(this.maximumValue.year, this.maximumValue.value - 1);
      result = dateToTest > maxDate;
    }
    return result;
  }
}
